<template>
  <div id="app">
    <div v-if="!isSignInPage && !isOtpPage && device.isDevice === false && showBanner === true" class="at-banner" >
      <div class="at-banner__content">
        <div class="at-banner__text">Turn on notifications on this device?</div>
        <a class="at-banner__button" @click="reg">TURN ON</a>
<!--        <a class="at-banner__button" @click="checkReg">CHECK</a>-->
<!--        <a class="at-banner__button" @click="check">Console</a>-->
      </div>
      <div class="at-banner__close" @click="closeBanner" ></div>
    </div>

    <Loader />
    <router-view/>
    <button v-if="showInstallPrompt" @click="installPWA" class="install-btn">
      Install App
    </button>
  </div>
</template>

<script>
import idHelper from '@/store/modules/helpers/indexedDB';
import Loader from "@/components/layout/Loader";
export default {
  components: {Loader},
  data() {
    return {
      deferredPrompt: null,
      showInstallPrompt: false,
      deviceId: null,
      isSignInPage: false,
      isOtpPage: false,
      showBanner: true,
      device: {
        isDevice: false,
      },
    };
  },
  computed: {
    // deviceId() {
    //   return this.$store.getters.getDeviceId;
    // }
  },
  async created() {
    this.deviceId = await idHelper.getDeviceID();
    this.checkPage();
    this.checkReg();
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallPrompt = true;
    });
  },
  beforeMount() {
    this.refreshData();
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler() {
        this.checkPage();
      }
    }
  },
  methods: {
    async installPWA() {
      if (!this.deferredPrompt) return;

      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;

      if (outcome === 'accepted' || outcome === 'dismissed') {
        this.deferredPrompt = null;
        this.showInstallPrompt = false;
      }
    },
    check() {
      console.log(this.deviceId);
    },
    refreshData() {
      return this.$store.dispatch('getPreLoginData', true);
    },
    closeBanner() {
      this.showBanner = false;
    },
    checkPage() {
      const currentRoute = this.$route.name;
      this.isSignInPage = currentRoute === 'login';
      this.isOtpPage = currentRoute === 'OTP';
    },
    reg() {
      this.$store.dispatch('checkAndRegisterDevice');
    },
    checkReg() {
      return axios.get(`${ticketApi}oneSignal/checkDeviceId/${this.deviceId}`)
          .then(response => {
            this.device = response.data;
            console.log('Data received:', this.device);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    }
  },
}
</script>

<style lang="scss">
#app {
  height: 100%;
}

#app > div > div.content-wrap {
  overflow-y: auto;
}

.at-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  background: rgba(63, 130, 247, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px;
  box-sizing: border-box;
  color: #FFFFFF;
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  animation: at-banner-slide-in 0.8s ease forwards;

  /* Added this to make sure it stays on top and never scrolls */
  pointer-events: auto;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: 0 auto;
    padding: 10px 40px;
  }

  &__text {
    margin: 0 20px 0 0;
  }

  &__button {
    background: #ffffff;
    color: #3F82F7;
    font-weight: 700;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    text-decoration: none;

    &:hover {
      background: #f0f4fc;
    }
  }

  &__close {
    position: absolute;
    top: 50%;
    right: 20px;
    width: 20px;
    height: 20px;
    transform: translateY(-50%);
    cursor: pointer;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      background: #FFFFFF;
      width: 100%;
      height: 3px;
      border-radius: 2px;
      transform-origin: center;
    }

    &:before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
}

@keyframes at-banner-slide-in {
  0% {
    transform: translateY(-150%);
  }

  100% {
    transform: translateY(0%);
  }
}
.install-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  padding: 12px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition:
      background-color 0.3s,
      transform 0.3s;
}

.install-btn:hover {
  background-color: #218838;
  transform: translateY(-3px);
}

.install-btn:active {
  transform: translateY(1px);
}
</style>
